module.exports = __webpack_public_path__ + "img/package_three.1209a105.jpg";